import { render, staticRenderFns } from "./PriceControl.vue?vue&type=template&id=647f413a&scoped=true&"
import script from "./PriceControl.vue?vue&type=script&lang=js&"
export * from "./PriceControl.vue?vue&type=script&lang=js&"
import style0 from "./PriceControl.vue?vue&type=style&index=0&id=647f413a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647f413a",
  null
  
)

export default component.exports